export enum InternetHeader {
    ProjectId = "X-BimTrack-FilingLocation",
    EmailId = "X-BimTrack-EmailId",
}
